import '../../assets/css/maint.css'
const Maintenence = () => {
  return (
    <div
      className='leftContainer page_layout'
    >
      <div className='Orher_page_main_section'>
        <div
          className='bg_maint'
          style={{ backgroundImage: "url('../images/web_maint.jpg')" }}
        ></div>
        <div className='bg_cont'>Online money gaming has been stopped as directed by the Government of India.</div>
      </div>
    </div>
  )
}

export default Maintenence
